import{
    FETCH_ORGANIZATIONS_FAILURE,
    FETCH_ORGANIZATIONS_SUCCESS,
    FETCH_ORGANIZATIONS_REQUEST
}
from '../actions/organizationAction';

const initialState = {
    organizations: [],
    loading: false,
    error: null,
  };
  const organizationReducer = (state = initialState, action) => {
      switch (action.type) {
          case FETCH_ORGANIZATIONS_REQUEST:
              return { ...state, loading: true, error: null };
          case FETCH_ORGANIZATIONS_SUCCESS:
              return { ...state, loading: false, organizations: action.payload };
          case FETCH_ORGANIZATIONS_FAILURE:
              return { ...state, loading: false, error: action.payload };
          default:
              return state;
      }
  };
  export default organizationReducer;